/**
 * Brand profile, activation history, and competitor radar API client.
 * All calls go through our own backend (authenticated via cookies).
 */
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const BASE = `${API}/api/brand`;
const http = axios.create({ withCredentials: true, timeout: 15000 });

export async function getBrandProfile() {
  const { data } = await http.get(`${BASE}/profile`);
  return data;
}

export async function updateBrandProfile(payload) {
  // payload: { primary_vertical?, secondary_verticals?, brand_name?, company_name? }
  const { data } = await http.put(`${BASE}/profile`, payload);
  return data;
}

export async function getNextMove() {
  const { data } = await http.get(`${BASE}/insights/next-move`);
  return data;
}

export async function getActivationHistory(limit = 20) {
  const { data } = await http.get(`${BASE}/activations/history`, { params: { limit } });
  return data;
}

export async function getLiveWaves() {
  const { data } = await http.get(`${BASE}/waves/live`);
  return data;
}

export async function getTrends() {
  const { data } = await http.get(`${BASE}/trends`);
  return data;
}

export async function getCompetitorRadar() {
  const { data } = await http.get(`${BASE}/competitors/radar`);
  return data;
}
